// Sentinels for the `outbreakAlerts` entries returned by hcx-infection-case-api on case
// create, plus the user-facing copy the prompt flow needs. Values marked "API" are part
// of that contract.

// API: matchingCases[].unitId when the case has no unit (the column is NOT NULL).
export const NO_UNIT_ID = 0;
export const NO_UNIT_LABEL = "No unit";

// API: matchingCases[].clientType (numeric enum ClientType { Client = 0, Staff = 1 }).
export const MatchingCaseClientType = Object.freeze({
  Resident: 0,
  Staff: 1,
});

export const CLIENT_TYPE_LABELS = Object.freeze({
  [MatchingCaseClientType.Resident]: "Resident",
  [MatchingCaseClientType.Staff]: "Staff",
});

export const OUTBREAK_EDITOR_TITLE = "New Outbreak Record";

export const OUTBREAK_CREATE_FAILED_MESSAGE = "The outbreak record could not be created. The infection case was saved; you can create the outbreak from Outbreak Management.";

// The case(s) already exist when linking fails, so tell the user what to finish by hand.
export const linkFailureMessage = (failedCount, total) =>
  total === 1
    ? "The case was saved but could not be linked to the outbreak. Link it from Outbreak Management."
    : `${failedCount} of ${total} cases could not be linked to the outbreak. Link them from Outbreak Management.`;
